import * as React from 'react';

var NotificationType;
(function (NotificationType) {
    NotificationType["Info"] = "info";
    NotificationType["Error"] = "error";
    NotificationType["Warning"] = "warning";
    NotificationType["Success"] = "success";
})(NotificationType || (NotificationType = {}));
function isNotification(message) {
    return message.timeout !== undefined;
}
// Default context is in essence a no-op one, where notifications are basically ignored
const NotificationsContext = React.createContext({
    isTopMost: null,
    send: (value) => value.key,
    dismiss: () => undefined,
    sendTopMost: (value) => value.key,
    dismissTopMost: () => undefined,
});

export { NotificationType, NotificationsContext, isNotification };
